import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TApiResError, TMessageError } from '@core/models';
import { TranslocoService } from '@jsverse/transloco';
import * as Joi from 'joi';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class HttpErrorToastService {
  /**
   * Api validation scheme
   */
  errorResponseSchema = Joi.object({
    resultMsg: Joi.string().empty().required(),
    resultCode: Joi.string().empty(),
    resultDetails: Joi.array().items(Joi.string()),
    httpStatus: Joi.number(),
  });
  constructor(
    private readonly messageService: MessageService,
    private readonly translocoService: TranslocoService
  ) {}

  handle(error: HttpErrorResponse) {
    /**
     * Check the schema
     */
    const schemaValidate = this.errorResponseSchema.validate(error.error, { abortEarly: false });
    if (schemaValidate.error) {
      let toastDetail = `${error.status} - ${error.error}`;

      if (error.status === 404) toastDetail = this.translocoService.translate('error.status_404');
      if (error.status === 500) toastDetail = this.translocoService.translate('error.status_500');
      if (error.status === 0) toastDetail = this.translocoService.translate('error.status_0');

      this.messageService.add({
        severity: 'error',
        detail: toastDetail,
        life: 6000,
        icon: 'pi-times',
      });

      return;
    }

    /**
     * Common error messages
     */
    const apiError: TApiResError = error.error;

    const toastText: TMessageError = {
      title: '',
      message: apiError.resultMsg,
      data: apiError.resultDetails,
    };

    this.messageService.add({
      severity: 'error',
      styleClass: 'data-text-small',
      summary: toastText.title,
      detail: toastText.message,
      data: toastText.data,
      life: 20000,
      icon: 'pi-times',
    });
  }
}
